/**
 * BarChart: vertical bars, one or two series per label (second series is striped).
 * Props: see CartesianProps in CartesianChart.tsx.
 * Example: <BarChart caption="Orders per day" labels={days} series={[{ key: 'n', label: 'Orders', values }]} formatValue={String} />
 */
import { CartesianChart, CartesianProps } from './CartesianChart';

export type BarChartProps = CartesianProps;

export const BarChart = (props: BarChartProps) => <CartesianChart kind="bar" {...props} />;
